<template>
    <dx-form
        ref="formRef"
        v-model:form-data="state.userRequestBody"
        :show-validation-summary="false"
        id="form"
        class="custom-users-card"
    >
        <dx-group-item :col-count="2" cssClass="pb-[16px!important]">
            <dx-group-item cssClass="bg-[#F6FAFE] p-[20px!important] rounded-xl mr-2">
                <dx-group-item :col-count="2">
                    <dx-simple-item cssClass="p-0">
                        <label class="text-base font-medium">Параметры аккаунта:</label>
                    </dx-simple-item>

                    <dx-simple-item
                        cssClass="mt-1 p-0"
                        :label="{ visible: false }"
                        :editor-options="{
                            text: 'Пользователь AD',
                            value: state.userRequestBody.from_ad,
                            disabled: true,
                        }"
                        data-field="from_ad"
                        editor-type="dxCheckBox"
                    >
                    </dx-simple-item>
                </dx-group-item>
                <dx-simple-item
                    cssClass="custom-padding-textbox-and-selectbox"
                    :is-required="true"
                    data-field="user_login"
                    :label="{ text: 'Логин:' }"
                    :editorOptions="{
                        readOnly: state.mode !== MODE.CREATE,
                    }"
                >
                    <dx-required-rule message="Поле должно быть заполнено" />

                </dx-simple-item>

                <dx-simple-item
                    cssClass="custom-padding-textbox-and-selectbox"
                    data-field="e_mail"
                    :label="{ text: 'Электронная почта:' }"
                    :editorOptions="{
                        readOnly: true,
                    }"
                />

                <dx-simple-item
                    cssClass="custom-padding-textbox-and-selectbox"
                    :label="{ text: 'Срок действия пароля:' }"
                    data-field="expired_at"
                    name="user_password"
                    editor-type="dxDateBox"
                    :editorOptions="{
                        type: 'datetime',
                        displayFormat: 'dd.MM.yy - HH:mm',
                        readOnly: true,
                        openOnFieldClick: true,
                        useMaskBehavior: true,
                        showClearButton: true,
                    }"
                >
                </dx-simple-item>

                <dx-simple-item
                    cssClass="custom-padding-textbox-and-selectbox"
                    :label="{ text: 'Тип учетной записи:' }"
                    editor-type="dxSelectBox"
                    :editorOptions="{
                        readOnly: isToolbarElementsDisabled || state.mode === MODE.VIEW,
                        dataSource: state.userTypes,
                        value: state.userRequestBody.user_type_id,
                        displayExpr: 'name',
                        valueExpr: 'id',
                        onValueChanged: changedUserType,
                    }"
                />
                <dx-group-item :col-count="columnCount" cssClass="custom-padding-textbox-and-selectbox">
                    <dx-simple-item
                        cssClass="pb-0"
                        :is-required="true"
                        data-field="request_number"
                        :label="{ text: 'Номер заявки:' }"
                        :editorOptions="{
                            readOnly: isToolbarElementsDisabled || state.mode === MODE.VIEW,
                        }"
                    />
                    <dx-simple-item
                        cssClass="p-0"
                        :is-required="true"
                        data-field="request_date"
                        editor-type="dxDateBox"
                        :label="{ text: 'Дата заявки:' }"
                        :editorOptions="{
                            readOnly: isToolbarElementsDisabled || state.mode === MODE.VIEW,
                            ...dateBoxOptions,
                        }"
                    />
                </dx-group-item>
            </dx-group-item>

            <dx-group-item cssClass="bg-[#F6FAFE] p-[20px!important] rounded-xl ml-2">
                <dx-simple-item class="custom-padding-textbox-and-selectbox">
                    <label class="text-base font-medium">Параметры сотрудника:</label>
                </dx-simple-item>
                <dx-simple-item
                    cssClass="custom-padding-textbox-and-selectbox"
                    data-field="fio"
                    :label="{ text: 'ФИО:' }"
                    :editorOptions="{
                        readOnly: true,
                    }"
                />
                <dx-simple-item
                    cssClass="custom-padding-textbox-and-selectbox"
                    data-field="namedolzh"
                    :label="{ text: 'Должность:' }"
                    :editorOptions="{
                        readOnly: true,
                    }"
                />
                <dx-simple-item
                    cssClass="custom-padding-textbox-and-selectbox"
                    data-field="department"
                    :label="{ text: 'Подразделение:' }"
                    :editorOptions="{
                        readOnly: true,
                    }"
                />
                <dx-simple-item
                    cssClass="custom-padding-textbox-and-selectbox"
                    data-field="mobile_phone"
                    :label="{ text: 'Мобильный телефон:' }"
                    :editorOptions="{
                        readOnly: true,
                    }"
                />
                <dx-simple-item
                    cssClass="custom-padding-textbox-and-selectbox"
                    data-field="phone"
                    :label="{ text: 'Рабочий телефон:' }"
                    :editorOptions="{
                        readOnly: true,
                    }"
                />
            </dx-group-item>
        </dx-group-item>

        <dx-group-item cssClass="bg-[#F6FAFE] rounded-xl p-[20px!important]">
            <dx-group-item :col-count="3" cssClass="w-[85%] p-0">
                <dx-simple-item class="custom-padding-textbox-and-selectbox flex">
                    <label class="text-base font-medium p-0">Настройка оповещений:</label>
                </dx-simple-item>
                <dx-simple-item
                    cssClass="mt-1 p-0"
                    data-field="notification_email"
                    :label="{ visible: false }"
                    editor-type="dxCheckBox"
                    :editor-options="{
                        text: 'Отправлять на электронную почту',
                        value: state.userRequestBody.notification_email,
                        disabled: true,
                        onValueChanged: changedEmailOrPush,
                    }"
                />
                <dx-simple-item
                    cssClass="mt-1 p-0"
                    data-field="notification_push"
                    :label="{ visible: false }"
                    editor-type="dxCheckBox"
                    :editor-options="{
                        text: 'Отправлять Push-сообщения',
                        value: state.userRequestBody.notification_push,
                        disabled: true,
                        onValueChanged: changedEmailOrPush,
                    }"
                />
            </dx-group-item>
            <dx-group-item :col-count="2" cssClass="p-0">
                <dx-simple-item
                    cssClass="custom-padding-textbox-and-selectbox"
                    :is-required="isEmailOrPush"
                    data-field="notification_days"
                    :label="{ text: 'Количество дней до срока исполнения:', class: 'p-[0px!important]' }"
                    :editor-options="{
                        readOnly: isToolbarElementsDisabled || !isEmailOrPush,
                        disabled: true,
                    }"
                />

                <dx-simple-item
                    cssClass="custom-padding-textbox-and-selectbox"
                    :is-required="isEmailOrPush"
                    data-field="notification_time"
                    :label="{ text: 'Время напоминаний:' }"
                    editor-type="dxDateBox"
                    :editor-options="{
                        type: 'time',
                        dateSerializationFormat: 'HH:mm:ss',
                        useMaskBehavior: true,
                        openOnFieldClick: true,
                        showClearButton: true,
                        readOnly: isToolbarElementsDisabled || !isEmailOrPush,
                        disabled: true,
                    }"
                />
            </dx-group-item>
        </dx-group-item>
    </dx-form>
</template>
<script>
export default {
    name: 'users-card',
};
</script>
<script setup>
import { ref, onMounted, computed, nextTick } from 'vue';
import {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxRequiredRule,
} from 'devextreme-vue/form';
import enviromentStore from '@/store/enviroment-data';
import usersLocalStore from './store';
import usersStore from '@/store/administration/users';

const { disableUiElement } = enviromentStore;
const { setFormRef } = usersStore;
const { state, MODE, UI_ELEMENTS_IDS } = usersLocalStore;

const isToolbarElementsDisabled = disableUiElement(UI_ELEMENTS_IDS.PERSONAL_INFORMATION)
const formRef = ref();
const isViewMode = computed(() => state.mode === MODE.VIEW);
const columnCount = computed(() => (isViewMode.value ? 1 : 2));
const isEmailOrPush = computed(() =>
    state.userRequestBody.notification_email || state.userRequestBody.notification_push,
);

const dateBoxOptions = computed(() => ({
    openOnFieldClick: true,
    disabled: isViewMode.value,
    readOnly: isToolbarElementsDisabled,
    displayFormat: 'dd.MM.yy - HH:mm',
    useMaskBehavior: true,
    showClearButton: true,
    type: 'datetime',
}));

onMounted(async () => {
    setFormRef(formRef.value);
    await nextTick();
});

const changedEmailOrPush = () => {
    if (!state.userRequestBody.notification_email && !state.userRequestBody.notification_push) {
        state.userRequestBody.notification_days = null;
        state.userRequestBody.notification_time = null;
    }
};

const changedUserType = event => {
    state.userRequestBody.user_type_id = event.value;
};
</script>

<style lang="scss">
.custom-users-card {
    .custom-padding-textbox-and-selectbox {
        padding-top: 10px !important;
        padding-bottom: 0 !important;
    }

    .dx-field-item-label-content {
        .dx-field-item-label-text {
            color: black !important;
        }
    }

    .dx-field-item-label-location-top {
        padding: 0 0 3px;
    }

    .dx-texteditor-container {
        border-radius: 5px !important;
    }

    .dx-texteditor-input,
    .dx-texteditor-buttons-container {
        background-color: #e3f1ff;
    }

    .dx-state-readonly {
        border-radius: 5px !important;

        .dx-texteditor-input {
            background-color: #e0e0e0 !important;
        }
    }
}

.dx-field-item-required-mark {
    color: red;
}
</style>
